import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { forumUntrustworthyUserFeedUrl } from "@/mk2/apps/forum/urls";
import { Interpolate } from "@/mk2/components/Interpolate";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { url } from "@/mk2/helpers/urls";
import { UserEntity } from "@/mk2/schemas";
import { interpolate } from "@/mk2/services/i18n";
import {
    UNTRUSTWORTHY_USER_ALERT_HEADING_user,
    UNTRUSTWORTHY_USER_ALERT_INFO_link,
    UNTRUSTWORTHY_USER_ALERT_LINK_user,
} from "@/mk/autogenerated/translations/UntrustworthyUserAlert.76f4c133b00174ab599efd1d21f735a8";

import styles from "./UntrustworthyUserAlert.mscss";

interface OwnProps {
    /** Add custom classname to container */
    className?: string;

    /** Untrustworthy User  */
    user: UserEntity;
}

export const UntrustworthyUserAlert: React.FunctionComponent<OwnProps> = ({ user, className }) => (
    <div className={cx(styles.UntrustworthyUserAlert, className)}>
        <div className={styles.UntrustworthyUserAlert__heading}>
            <span className={styles.UntrustworthyUserAlert__heading__icon}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>{" "}
            {interpolate(UNTRUSTWORTHY_USER_ALERT_HEADING_user, { user: user.username })}
        </div>
        <div className={styles.UntrustworthyUserAlert__info}>
            <Interpolate
                i18nKey={UNTRUSTWORTHY_USER_ALERT_INFO_link}
                link={
                    <Link
                        to={url(forumUntrustworthyUserFeedUrl, { username: user.username })}
                        className={styles.UntrustworthyUserAlert__link}
                    >
                        {interpolate(UNTRUSTWORTHY_USER_ALERT_LINK_user, { user: user.username })}
                    </Link>
                }
            />
        </div>
    </div>
);

export const UntrustworthyUserAlertPlaceholder: React.FunctionComponent<{ className?: string }> = ({
    className,
}) => (
    <div className={cx(styles.UntrustworthyUserAlert, className)}>
        <div className={styles.UntrustworthyUserAlert__heading}>
            <LoadingPlaceholder width={250} height={18} />
        </div>
        <div className={styles.UntrustworthyUserAlert__info}>
            <LoadingPlaceholder width="100%" />
            <LoadingPlaceholder width="40%" />
        </div>
    </div>
);
